export default __webpack_public_path__ + "static/media/few-clouds-day.d1087dd0.svg";